<template>
    <div class="user-notification-orders">
        <section class="orders-table">
            <ek-table
                :items="jobs"
                :columns="columns"
                @details="navigateToNotificationOrderDetails"
                no_delete
                no_select
            >
                <template slot="items.submitDate" slot-scope="{ value }">
                    {{
                        value
                            ? new Date(value)
                                  .toLocaleString("en-UK")
                                  .split(",")
                                  .reverse()
                                  .join(" ")
                            : "-"
                    }}
                </template>
            </ek-table>
        </section>
    </div>
</template>

<script>
import { mapMutations, mapState } from "vuex";

export default {
    computed: {
        ...mapState({
            jobs: ({ users }) => users.jobs,
        }),
    },
    data: () => ({
        range: [],
        filter: {
            dateRange: "",
            status: null,
            senderId: null,
        },
        columns: [
            {
                label: " عنوان الإشعار",
                field: "accountName",
            },
            {
                label: "المسمى الوظيفي",
                field: "jobName",
            },
            {
                label: "تاريخ الإشعار",
                field: "submitDate",
            },
            {
                label: "تفاصيل",
                field: "details",
                sortable: false,
            },
        ],
    }),
    props: {
        id: String
    },  
    methods: {
        ...mapMutations(["Reset_Orders_Dto"]),
        navigateToNotificationOrderDetails({ row }) {
            this.$router.push(`/admin/users/${this.id}/jobs/${row.jobId}/jobInfoId/${row.jobInfoId}`);
        },
        formatOrdersDate(startDate, endDate) {
            return `${new Date(startDate).toLocaleDateString()}-${new Date(
                endDate
            ).toLocaleDateString()}`;
        },
        navigateToOrdersDetails(id) {
            this.$router.push(`/admin/orders/${id}`);
        },
        beforeDestroy() {
            this.$store.commit("Reset_Search_Dto");
        },
    },
};
</script>
